import { useReducer } from "react";
import { useFunctionWithDelay } from "../../../utils/Hooks";
import {
  AREA_SEARCH,
  MANAGER_SEARCH,
  CORPORATION_SEARCH,
  POSITION_SEARCH,
} from "./constants";

export const useDelayedEmployeeFormSearchReducer = () => {
  const initialState = {
    managerSearch: "",
    areaSearch: "",
    corporationSearch: "",
    positionSearch: "",
  };

  const searchReducer = (state, action) => {
    switch (action.type) {
      case AREA_SEARCH:
        return {
          ...state,
          areaSearch: action.payload,
        };
      case MANAGER_SEARCH:
        return {
          ...state,
          managerSearch: action.payload,
        };

      case CORPORATION_SEARCH:
        return {
          ...state,
          corporationSearch: action.payload,
        };
      case POSITION_SEARCH:
        return {
          ...state,
          positionSearch: action.payload,
        };
      default:
        return state;
    }
  };
  const [state, dispatch] = useReducer(searchReducer, initialState);
  const delayedDispatcher = useFunctionWithDelay(dispatch);

  return [state, delayedDispatcher];
};
